<template>
<div id="Findthenumber" class="routes_components findthenumber_view">
  <div class="row score_row">
    <div class="col text-right score_div ftn_padding">
      <span>Guesses <span class="score">&nbsp;{{guesses}}</span></span>
    </div>
    <div class="col text-center score_div empty_div ftn_padding">

    </div>
    <div class="col text-left score_div ftn_padding">
      <span v-if="mode == '2_digit'">Numbers <span class="score">&nbsp;0-99</span></span>
      <span v-if="mode == '3_digit'">Numbers <span class="score">&nbsp;0-999</span></span>
      <span v-if="mode == '4_digit'">Numbers <span class="score">&nbsp;0-9999</span></span>
    </div>
  </div>
  <div class="center_div_ftn">
    <div class="ftn_wrap">
      <div class="ftn_main">
        <div class="lower_col" id="lower_div">
          <div class="col_heading">
            Lower
          </div>
          <div class="values_ftn" id="values_ftn_lower">
            <div class="lower_value" v-for="(number,index) in number_lower" :key="index">
              {{ number }}
            </div>
            <div>
              &nbsp;
            </div>
          </div>
        </div>
        <div class="center_col_ftn">
          <div class="" id="success" v-b-popover.bottom="success">
            <div class="hidden_num_div text-center">{{number_found}}</div>
          </div>
        </div>
        <div class="higher_col" id="higher_div">
          <div class="col_heading">
            Higher
          </div>
          <div class="values_ftn" id="values_ftn_higher">
            <div class="higher_value" v-for="(number,index) in number_higher" :key="index">
              {{ number }}
            </div>
            <div>
              &nbsp;
            </div>
          </div>
        </div>
      </div>
      <div class="input_ftn numpad_ftn">
        <div class="input_ftn_div">
          <input type="number" v-model="display_value" v-on:keyup.enter="okay_clicked()">
          <button class="num_btn num_btn_okay" @click="okay_clicked()">
            Submit&nbsp;
          </button>
        </div>
        <span>&nbsp;</span>
        <span v-if="two_error == true">Enter number between 0-99</span>
        <span v-if="three_error == true">Enter number between 0-999</span>
        <span v-if="four_error == true">Enter number between 0-9999</span>
      </div>
    </div>
  </div>
  <div class="row options_row">
    <div class="col text-center p-0 m-0 tic_buttons_1 ">
      <div class="switch-field switch_one switch_ftn">
        <input type="radio" id="radio-three" name="switch-two" v-model="mode" value="2_digit" :disabled="disable_mode" />
        <label for="radio-three">2 Digit</label>
        <input type="radio" id="radio-four" name="switch-two" v-model="mode" value="3_digit" :disabled="disable_mode" />
        <label for="radio-four">3 Digit</label>
        <input type="radio" id="radio-five" name="switch-two" v-model="mode" value="4_digit" :disabled="disable_mode" />
        <label for="radio-five">4 Digit</label>
      </div>
    </div>

    <div class="col text-center p-0 m-0 tic_buttons_3 ftn_switch_2">
      <button type="button" class="reset_button reset_button_ftn" name="button" @click="reset()">Reset</button>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'Findthenumber',
  data() {
    return {
      success: "Found",
      hidden_number: "100",
      number_found: "Number",
      mode: "2_digit",
      display_value: "",
      disable_mode: false,
      guesses: 0,
      number_higher: [],
      number_lower: [],
      two_error: false,
      three_error: false,
      four_error: false
    }
  },
  mounted() {
    this.set_hidden_number_2digit();
    this.$root.$emit('bv::disable::popover', 'success');
  },
  beforeRouteLeave(to, from, next) {
    next();
    this.reset();
  },
  methods: {
    check_enter(){
      alert('enetr')
    },
    set_hidden_number_2digit() {
      var new_number = Math.floor((Math.random() * 99) + 1);
      this.hidden_number = new_number;
    },
    set_hidden_number_3digit() {
      var new_number = Math.floor((Math.random() * 999) + 1);
      this.hidden_number = new_number;
    },
    set_hidden_number_4digit() {
      var new_number = Math.floor((Math.random() * 9999) + 1);
      this.hidden_number = new_number;
    },
    okay_clicked() {
      if (this.mode == "2_digit" && Number(this.display_value) >= 0 && Number(this.display_value) <= 99 && this.display_value != "" ||
        this.mode == "3_digit" && Number(this.display_value) >= 0 && Number(this.display_value) <= 999 && this.display_value != "" ||
        this.mode == "4_digit" && Number(this.display_value) >= 0 && Number(this.display_value) <= 9999 && this.display_value != "") {
        if (Number(this.display_value) < Number(this.hidden_number)) {
          this.number_lower.push(this.display_value);
          var scroll_lower = document.getElementById('values_ftn_lower');
          scroll_lower.scrollTop = scroll_lower.scrollHeight - scroll_lower.clientHeight;
          this.display_value = "";
          this.guesses++;
        } else if (Number(this.display_value) > Number(this.hidden_number)) {
          this.number_higher.push(this.display_value);
          var scroll_higher = document.getElementById('values_ftn_higher');
          scroll_higher.scrollTop = scroll_higher.scrollHeight - scroll_higher.clientHeight;
          this.display_value = "";
          this.guesses++;
        } else if (Number(this.display_value) == Number(this.hidden_number)) {
          this.display_value = "";
          this.number_found = this.hidden_number,
            this.$root.$emit('bv::enable::popover', 'success');
          this.$root.$emit('bv::show::popover', 'success');
          setTimeout(function() {
            this.$root.$emit('bv::hide::popover', 'success');
            this.$root.$emit('bv::disable::popover', 'success');
            this.reset();
          }.bind(this), 3000);
        }
      }
    },
    reset() {
      this.hidden_number = "100";
      this.mode = "2_digit";
      this.display_value = "";
      this.disable_mode = false;
      this.number_found = "Number";
      this.number_higher = [];
      this.guesses = 0;
      this.number_lower = [];
      this.two_error = false;
      this.three_error = false;
      this.four_error = false;
    }
  },
  watch: {
    mode: function(new_value) {
      if (new_value == "3_digit") {
        this.set_hidden_number_3digit();
      } else if (new_value == "4_digit") {
        this.set_hidden_number_4digit();
      } else if (new_value == "2_digit") {
        this.set_hidden_number_2digit();
      }
    },
    display_value: function(new_value) {
      if (this.mode == "2_digit" && new_value > 99) {
        this.two_error = true
      } else if (this.mode == "2_digit" && new_value < 99) {
        this.two_error = false
      }

      if (this.mode == "3_digit" && new_value > 999) {
        this.three_error = true
      } else if (this.mode == "3_digit" && new_value < 999) {
        this.three_error = false
      }

      if (this.mode == "4_digit" && new_value > 9999) {
        this.four_error = true
      } else if (this.mode == "4_digit" && new_value < 9999) {
        this.four_error = false
      }

    }
  },
}
</script>

<style>
</style>
